import { useMutation } from '@tanstack/react-query';
import { cancelLeg } from '../../../../../utils/OrderWebAPIUtils';
/**
 * Custom hook to cancel a leg
 */
export function useCancelLeg() {
    return useMutation({
        mutationFn: ({ legId, reason, comment, }) => cancelLeg(legId, reason, comment),
    });
}
